// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";

// 引Vant组件库
import "./vant";
import "vant/lib/index.css";

// 引入 自定义组件 并 设为全局组件
import Component from "./components";
Vue.use(Component);

// import VConsole from 'vconsole'
// new VConsole()

// 引入基础样式
import "./assets/css/base.css";
import "./assets/css/common.css";

// 引入config
import config from "./config";
Vue.prototype.$config = config;

// 引入自定义公共方法
import {CommFunc} from "./utils/commonFunc";
Vue.prototype.$conmonFunc = CommFunc;

 Vue.directive('preventReClick',{
	inserted: function(el, binding, vNode, oldVnode){
		el.addEventListener('click', () => {
			if(!el.disabled){
			    el.disabled = true
			    el.style.backgroundColor = '#ccc'
			    el.style.border = 'none'
       			setTimeout(() => {
          			el.disabled = false
          			 el.style.backgroundColor = '#1890ff'	
          			 el.style.border = '1px solid #1890ff'
        		}, 2000)
			}
		})
	}
})

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js